import React from 'react';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';

import { DateInput, TextInput } from 'components/input';

import {
  DisabledInputOptions,
  InputOptions
} from 'util/constants';

export const ShopReportResend = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
      <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
      <DateInput options={InputOptions} source="date" label="Date"/>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopReportResend.js